import React, { useState } from 'react';

import ProjectSettingsSwitches from './project-components/ProjectSettingsSwitches';
import ClientSelector from './project-components/ClientSelector';


import SelectSearchDroupDown from '../../components/DemoTabs/SelectSearchDroupDown';

import SelectDropDowns from '../DemoTabs/SelectDropDowns';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};





const ShareReport = ({ open, onClose }) => {

    // start File Type
    const [selectedFileType, setSelectedFileType] = useState('');
    const FileTypeData = [
        { name: 'PDF' },
        { name: 'CSV' },
    ];
    // End  File Type
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Share Report</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>

                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Email Address</Typography>
                        <TextField fullWidth placeholder="Enter the email address" variant="outlined" margin="normal"
                            sx={{
                                marginTop: '0', fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                    height: '40px', fontSize: '14px', color: '#64748B',fontFamily: 'Manrope',
                                    '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                }, '& .MuiInputBase-input': { padding: '10px 18px',fontFamily: 'Manrope' },
                            }} />
                    </Box>

                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Subject</Typography>
                        <TextField fullWidth placeholder="Enter the subject " variant="outlined" margin="normal"
                            sx={{
                                marginTop: '0', fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                    height: '40px', fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                    '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope'},
                                }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily: 'Manrope' },
                            }} />
                    </Box>

                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Message</Typography>
                        <TextField fullWidth multiline rows={3} placeholder="Enter the subject " variant="outlined" margin="normal"
                            sx={{
                                marginTop: '0',fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                    fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                    '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                }, '& .MuiInputBase-input': { padding: '0 0', fontFamily: 'Manrope' },
                            }} />
                    </Box>

                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>File Type</Typography>
                        <SelectDropDowns label="Select" options={FileTypeData} selectedValue={selectedFileType} onChange={setSelectedFileType} />
                    </Box>


                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Box display="flex" alignItems="center" sx={{gap:'14px'}}>
                        <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Preview
                        </Button>
                        <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                            Send
                        </Button>
                    </Box>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default ShareReport;
